import { render, staticRenderFns } from "./GlyphCleanButtonGroup.vue?vue&type=template&id=5a283db6&scoped=true"
import script from "./GlyphCleanButtonGroup.vue?vue&type=script&lang=js"
export * from "./GlyphCleanButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./GlyphCleanButtonGroup.vue?vue&type=style&index=0&id=5a283db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a283db6",
  null
  
)

export default component.exports